module.exports = __webpack_public_path__ + "assets/img/bg.7f5fe835.png";